<template>
   <div class="content-wrapper">
      <section class="content-header">
         <div class="row">
            <div class="col-xs-6">
               <h1> Add <span style="color:#00a65a">{{com_TVOwnerName()}}</span> PIN Validity </h1>
            </div>
            <div class="col-xs-6 mandatoryDiv">
               <span class="mandatory_color">(*)</span> <span class="letter-right"> Marked are required field</span>
            </div>
         </div>
      </section>
      <section class="content">
         <div class="row">
            <div class="col-sm-12">
               <div class="alert alert-info" v-if="alert_message">
                  {{alert_message}}
               </div>
            </div>
            <div class="col-sm-6">
               <div class="box">
                  <div class="box-header">
                     <h3 class="box-title">
                        Fill up the form to add validity
                     </h3>
                  </div>
                  <div class="box-body form-box-body form-horizontal">
                     <div class="form-group">
                        <div>
                           <label class="col-md-4 control-label">Number Of Days <span class="mandatory_horizontal">*</span></label>
                           <div class="col-md-8">
                              <input name="number_of_days" id="number_of_days" class="form-control input-sm" value="" v-model="number_of_days" placeholder="Number Of Days" type="number" onfocus="this.removeAttribute('readonly');" readonly="">
                              <label v-if="error_number_of_days" class="error" for="number_of_days">{{error_number_of_days}}</label>
                           </div>
                        </div>
                     </div>

                     <div class="form-group">
                        <div>
                           <label class="col-md-4 control-label">PIN in CSV or New Line <span class="mandatory_horizontal">*</span></label>
                           <div class="col-md-8">
                              <textarea name="username" id="username" v-model="username" class="form-control input-sm" rows="5" placeholder="Enter PIN e.g. 12345,65412,1233 Or just put a single pin in a new line" onfocus="this.removeAttribute('readonly');" readonly=""></textarea>
                              <label v-if="error_username" class="error" for="username">{{error_username}}</label>
                           </div>
                        </div>
                     </div>

                  </div>
               </div>
            </div>
         </div>
         <div class="row">
            <div class="col-sm-6 btnRight">
               <input type="submit" name="submit" value="Add Validity" class="btn btn-sm btn-submit btn-submit-big" @click="formSubmit">
            </div>
         </div>
      </section>
   </div>
</template>
<script>
   import axios from 'axios'
   export default {
     name: "FlexAddPinValidity",
     data() {
         return {
            userData : {},
            username : '',
            number_of_days : '',
            alert_message : '',
            flexApiUrl : process.env.VUE_APP_APIFLEXURL,
            error_username : false,
            error_number_of_days : false,
         }
      },
      created(){
         if(!this.com_isTVReseller(true, [393])){
            this.$router.push('dashboard');
         }
         var encryptedData = this.$store.getters.getUser;
         var decodedString  = this.com_DecryptString(encryptedData);
         this.userData = JSON.parse(decodedString);
         var rootObject = this;
      },
      methods: {
         formSubmit(e) {
            e.preventDefault();
            var rootObject = this;

            var result = this.fromValidation();
            if (result) {
               setTimeout(function(){  
                  rootObject.error_username = false;
                  rootObject.error_error_number_of_days = false;
               }, 5000);
               return 0;
            }

            loader.show(); 
            const form = new FormData()
            form.append('username', this.username)
            form.append('number_of_days', this.number_of_days)
            form.append('idReseller', rootObject.userData.id_reseller)
            form.append('level', rootObject.userData.user_level)

            var config = {
             headers: { 'Content-Type': 'multipart/form-data' }
            }

            axios.post(rootObject.flexApiUrl+'/add-pin-validity', form, config)
            .then(function (response) {
               //console.log(response);
               rootObject.alert_message =  "Pin Validity Added Successfully";
               rootObject.username =  "";
               rootObject.number_of_days =  "";
               loader.hide(); 
               setTimeout(function(){  
                  rootObject.alert_message = '';
                  rootObject.error_username = false;
                  rootObject.error_error_number_of_days = false;
               }, 5000);
            })
            .catch(function (error) {
               loader.hide(); 
               let alertmessage = "";
               for (var prop in error.response.data) {
                   alertmessage += ' '+error.response.data[prop]
               }
               console.log(alertmessage);
               rootObject.alert_message =  alertmessage;
               rootObject.com_errorHandel(error);
            });

            setTimeout(function(){  
               rootObject.alert_message = '';
               rootObject.error_username = false;
               rootObject.error_error_number_of_days = false;
            }, 5000);
         },

         fromValidation(reset = false){
            var has_error = false;
            if(!this.username){
               this.error_username = "This field is required";
               has_error = true;
            }

            if(!this.number_of_days){
               this.error_number_of_days = "This field is required";
               has_error = true;
            }

            if (has_error) {
               return true;
            }else{
               return false;
            }
         }

      },
      mounted: function() {
         //
      }
   };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>